module.exports = __webpack_public_path__ + "img/logo-komerce-new-tag.19fad26f.png";